export default __webpack_public_path__ + "static/1462-7c2712105c002e5b74b116a384abb52f.gif";